import React, { Children } from 'react';
import './LayeredImage.scss';

function LayeredImage({ image, bgImage }) {
  return (
    <div className="layered-image">
      <div className="top-image">
        <img src={image} />
      </div>
      <div className="bottom-image">
        <img src={bgImage ? bgImage : image} />
      </div>
    </div>
  );
}

export { LayeredImage };
